import {
  ToggleButtonGroup as MuiToggleButtonGroup,
  type ToggleButtonGroupProps as MuiToggleButtonGroupProps,
  ToggleButton
} from '@mui/material'
import { useController, useFormContext } from 'react-hook-form'

import type { FormElementProps } from './utils'

type ToggleButtonOption = { value: string; label: string }
export type ToggleButtonGroupProps = FormElementProps & {
  buttons: ToggleButtonOption[]
  onChange?: (values: string[]) => void
  slotProps?: {
    toggleButtonGroup?: MuiToggleButtonGroupProps
  }
}

export default function ToggleButtonGroup(props: ToggleButtonGroupProps) {
  const { buttons, disabled, name, onChange, slotProps } = props
  const { control } = useFormContext()
  const { field } = useController({ name, control })

  return (
    <MuiToggleButtonGroup
      {...field}
      size="small"
      onChange={(e, value) => {
        field.onChange(value)
        onChange?.(value)
      }}
      {...slotProps?.toggleButtonGroup}
    >
      {buttons.map((button) => (
        <ToggleButton key={button.value} disabled={disabled} value={button.value}>
          {button.label}
        </ToggleButton>
      ))}
    </MuiToggleButtonGroup>
  )
}
